import { Card, Empty, Spin } from "antd";
import User from "models/user/user";
import React, { useEffect, useState } from "react";
import moment from "moment";

import { useDispatch, useSelector } from "react-redux";
import {
  allNotifications,
  fetchNotificationList,
  NotificationHasMore,
  readAllFlag,
} from "redux/notification/notificationSlice";
import {
  convertoUSFormat,
  DiaryEntryPage,
  DiaryStatusRoutes,
} from "utilities/generalUtility";
import InfiniteScroll from "../../../src/react-infinite-scroll-component";
import { useRef } from "react";

import { createSearchParams, Link, useNavigate } from "react-router-dom";
import NetworkCall from "network/networkCall";
import Request from "network/request";
import { BellOutlined } from "@ant-design/icons";
import LoadingSpinner from "common/components/loadingSpinner/loadingSpinner";
import {
  allDiaries,
  arciveDiaries,
  saveCurrentDiary,
  saveDiaryStatus,
  saveFromNotificationFlag,
  saveHideClassName,
} from "redux/diaries/diariesSlice";

export default function Notifications() {
  const pageNumber = useRef(1);

  const dispatch = useDispatch();
  const id = User.getUserId();
  const notificationList = useSelector(allNotifications);
  const hasmore = useSelector(NotificationHasMore);
  const archiveDiaries = useSelector(arciveDiaries);
  const viewportWidth = window.innerWidth;

  const [isLoading, setIsLoading] = useState(false);
  const [smallLoading, setSmallLoading] = useState(false);
  const readFlag = useSelector(readAllFlag);
  //resolveit

  const diaries = useSelector(allDiaries);
  const navigate = useNavigate();

  const getNotification = async () => {
    setSmallLoading(true);
    pageNumber.current = pageNumber.current + 1;
    const body = {
      pageNumber: pageNumber.current,
      pageSize: 20,
      userId: id,
    };

    body.pageNumber !== 0 &&
      (await dispatch(fetchNotificationList(body, true)));
    setSmallLoading(false);
  };

  const redirect = async (value) => {
    try {
      const data = { notificationId: value?.id };
      const obj = JSON.parse(value?.body ?? value?.Body);
      let diary;
      NetworkCall.fetch(Request.markNotiAsRead(data), false);
      let check;
      if (obj?.DiaryId) {
        check = diaries?.findIndex(
          (e) => e?.diaryId === parseInt(obj?.DiaryId)
        );
        diary = (check === -1 ? archiveDiaries : diaries).find(
          (e) => e?.diaryId === obj?.DiaryId
        );
        dispatch(saveDiaryStatus({ diary }));

        if (obj?.DiaryTopicId) {
          dispatch(
            saveCurrentDiary({
              diaryId: obj?.DiaryId,
              topicId: obj?.DiaryTopicId,
            })
          );
        } else {
          dispatch(
            saveCurrentDiary({
              diaryId: diary?.diaryId,
              topicId: diary?.topics[0]?.id,
              topicName: diary?.topics[0]?.name,
            })
          );
        }
      }
      if (value?.type === 3 || value?.Type === 3) {
        if (viewportWidth < 700) {
          dispatch(saveHideClassName("sider-none"));
        }
      }
      dispatch(saveFromNotificationFlag(true));
      const params = `?diaryId=${obj?.DiaryId}&diaryTopicId=${
        obj?.DiaryTopicId
      }${
        check === -1
          ? "&archivedNotification=true"
          : "&archivedNotification=false"
      }`;
      navigate(
        `${DiaryStatusRoutes[diary?.status?.id] ?? "/journal-request"}${params}`
      );
    } catch (error) {}

    //if only diaryID then find the diary from diaries and then that diary id     dispatch(saveDiaryStatus({ diary }));
    // and if topicID as well then same as previous and diary topic id and diary id to        dispatch(saveCurrentDiary({ diaryId, topicId, topicName }));
  };

  const markAllRead = async () => {
    setIsLoading(true);
    try {
      await NetworkCall.fetch(Request.markNotiAsRead({}), false);
      await dispatch(
        fetchNotificationList(
          { pageNumber: 1, pageSize: 20, userId: id },
          false
        )
      );
      setIsLoading(false);
    } catch (error) {
      setIsLoading(true);
    }
  };

  const redirectToDiary = (e) => {
    // !queryDiaryId &&
    e && DiaryEntryPage(createSearchParams, e);
  };
  const NotificationTitle = (
    <>
      <BellOutlined />
      Notifications
    </>
  );
  const [checkRead, setCheckRead] = useState(true);
  useEffect(() => {
    setCheckRead(true);
    notificationList?.length >= 0 ? setIsLoading(false) : setIsLoading(true);
    notificationList &&
      notificationList.map((noti) => !noti.isRead && setCheckRead(false));
  }, [notificationList]);
  return (
    <>
      <Card
        className="notifications-card"
        title={NotificationTitle}
        // id="scrollableDiv"
        // style={{ height: 300, overflow: "auto" }}
        extra={
          !checkRead && (
            <Link
              disabled={checkRead}
              onClick={() => {
                markAllRead();
              }}
            >
              Mark all as read
            </Link>
          )
        }
      >
        {!isLoading ? (
          <>
            <div id="scrollableDiv">
              <InfiniteScroll
                className="card-scroll height-with-notif"
                dataLength={notificationList}
                next={getNotification}
                hasMore={hasmore}
                height={700}
                scrollableTarget="scrollableDiv"
                // loader={isLoading && <Spin className="bottom-loading" />}
                // loader={<h3>loader</h3> }
              >
                <ul className="notification-content-wrap">
                  {notificationList && notificationList?.length > 0 ? (
                    notificationList.map((e) => {
                      return (
                        // <Link to="/">
                        <li
                          onClick={() => redirect(e)}
                          style={{
                            cursor: "pointer",
                            backgroundColor: `${
                              e.isRead ? "#FFFFFF" : "#F6F9FF"
                            }`,
                          }}
                        >
                          {e.message ?? e.Message}
                          <span>
                            {convertoUSFormat(
                              moment,
                              e.createdAt ?? e.CreatedAt
                            )}{" "}
                          </span>
                        </li>
                        // </Link>
                      );
                    })
                  ) : (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="No Notification Found"
                    />
                  )}
                </ul>
              </InfiniteScroll>
            </div>
            {smallLoading && (
              <Spin spinning={smallLoading} className="bottom-loading" />
            )}
          </>
        ) : (
          <LoadingSpinner />
        )}
      </Card>
    </>
  );
}
